import React from "react";
import Edit from "../assets/Edit.jsx";
import Delete from "../assets/Delete.jsx";

const defaultRender = (value) => (value ?? "--");

const getEducationUnitsColumns = (onEdit, onDelete) => [
  {
    title: "Title",
    dataIndex: "title",
    sorter: true,
    render: defaultRender,
  },
  {
    title: "Description",
    dataIndex: "description",
    sorter: true,
    render: (text) => (text ? (text.length > 80 ? `${text.substring(0, 80)}...` : text) : "--"),
  },
  {
    title: "Unit Order",
    dataIndex: "unitOrder",
    sorter: true,
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "isActive",
    sorter: true,
    render: (isActive) =>
      isActive ? (
        <span className="px-3 py-1 rounded-full uppercase text-xs text-center success_tag">
          Active
        </span>
      ) : (
        <span className="uppercase px-3 py-1 rounded-full text-xs text-center fail_tag">
          Inactive
        </span>
      ),
  },
  {
    title: "Actions",
    dataIndex: "id",
    render: (_, record) => (
      <div className="flex items-center gap-2">
        <button type="button" onClick={() => onEdit(record)}>
          <Edit />
        </button>
        <button type="button" onClick={() => onDelete(record)}>
          <Delete />
        </button>
      </div>
    ),
  },
];

export default getEducationUnitsColumns;
